module.exports = __webpack_public_path__ + "static/10400556_21575687223_9030_n-61fc09703b7d789e3d6a13eccec1be34.jpg";